import { render, staticRenderFns } from "./media.vue?vue&type=template&id=47de6f89&scoped=true"
import script from "./media.ts?vue&type=script&lang=ts&external"
export * from "./media.ts?vue&type=script&lang=ts&external"
import style0 from "./media.less?vue&type=style&index=0&id=47de6f89&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47de6f89",
  null
  
)

export default component.exports